import React, { useState, useEffect } from 'react';
import { get } from '../../utils/apiUtils';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useAuth } from '../../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faPeopleGroup, faBell, faRobot, faPlug, faPlus } from '@fortawesome/free-solid-svg-icons';
import { faBuilding, faCircleDown } from '@fortawesome/free-regular-svg-icons';
import DataTableBase from '../helpers/DataTable';
import {
  Input,
  SectionTitle,
  SubSectionTitle,
  ButtonSuccess,
  Button,
  FormGroup,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  FormRow,
  Label,
  FormRowFull,
  Toggle,
  ToggleInput,
  Divider,
  fadeIn,
  Textarea
} from '../../styles/PageStyles';
import { getUsersByGroup, getUsersCountByGroup } from '../../services/userService';
import Pagination from './Pagination';
import { getGroupsDetailsByName } from '../../services/accessControlService';



const GroupDetails = ({ groupItem, onSelectUser, onSaveGroup, onBackToGroupListing, isGroupVisible }) => {
  const { user, setUser } = useAuth();
  const [groupDetails, setGroupDetails] = useState({ name: '', company_cd: user.companyCd, status: "ACTIVE" });
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [debounceSearchQuery, setDebounceSearchQuery] = useState(searchTerm);
    
  const itemsPerPage = 10;
  useEffect(() => {
    // if (groupItem) {
    //   setGroupDetails(groupItem);
    // }
    const fetchGroupDetails = async (groupName) =>{
      try {
        const resp = await getGroupsDetailsByName(groupName);
        if(resp.length) {
          setGroupDetails(resp[0])
        }
      } catch (error) {
        console.log(`Error fetching the group details:`, error)
      }
    }
    if(groupItem?.group) {
      fetchGroupDetails(groupItem?.group);
    }
  }, [groupItem]);

  useEffect(() => {
  const timer = setTimeout(() => {
    setDebounceSearchQuery(searchTerm);
  }, 500);

  return () => clearTimeout(timer);
}, [searchTerm]);

console.log({debounceSearchQuery})
console.log({searchTerm})
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const query = { skip: (currentPage - 1) * itemsPerPage, limit: itemsPerPage };
        let filter = {}
        const sort = {};
        if (debounceSearchQuery) {
          filter = { 'name': { 'ilike': `${debounceSearchQuery}` } };
        }
        const resp = await getUsersByGroup(groupItem?.group, filter, sort, query)
        setUsers(resp)
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    if (groupItem) {
      fetchUsers();
    }
  }, [groupItem, user, debounceSearchQuery, currentPage]);


    useEffect(() => {
      const fetchUsersCount = async () => {
        try {
          let filter = {};
          if(debounceSearchQuery) {
            filter = {...filter,'name' :{ 'ilike' : `${debounceSearchQuery}`} }
          }
          const count = await getUsersCountByGroup(groupItem?.group, filter);
          setTotalItems(count);
        } catch (error) {
          console.log("Error while fetching agent count", error);
        }
      }
  
      if(groupItem?.group) {
        fetchUsersCount();
      }
    }, [debounceSearchQuery])


  // Get user initials for avatar
  const getUserInitials = (user) => {
    if (!user || !user.first_name) return 'U';
    return [user.first_name, user.last_name].map(n => n[0]).join('').toUpperCase();
  };

  // Get status badge color
  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'active';
      case 'connected': return 'active';
      case 'archived': return 'default';
      case 'disconnected': return 'error';
      default: return 'default';
    }
  };
  const getGender = (status) => {
    switch (status) {
      case 'M': return 'Male';
      case 'F': return 'Female';
      case 'Other': return 'Other';
      default: return 'default';
    }
  };
  const filteredUsers = users.filter((user) => {
    return user?.first_name?.toLowerCase().includes(searchTerm?.toLowerCase())
    // return user
  });

  return (
    <div>
      <SectionTitle>
        {groupDetails ? (
          <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
            Edit {groupDetails.name}
          </span>
        ) : (
          <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
            Add Group
          </span>
        )}

        {/* <span onClick={() => onBackToGroupListing && onBackToGroupListing()} style={{ cursor: 'pointer' }}>Back</span> */}
      </SectionTitle>
      {isGroupVisible && <div>
        <Divider /> 
      <FormRow>
        <FormGroup>
          <Label>Name</Label>
          <Input type="text" value={groupDetails?.name || ''}
            onChange={(e) => setGroupDetails({ ...groupDetails, name: e.target.value })}
          />

        </FormGroup>
        <FormGroup>
          <Label>Company</Label>
          <Input type="text" disabled value={groupDetails?.company_cd || ''}
            onChange={(e) => setGroupDetails({ ...groupDetails, company_cd: e.target.value })} />
        </FormGroup>
      </FormRow>
      <FormRowFull>
        <FormGroup>
          <Label>Description</Label>
          <Textarea type="text" value={groupDetails?.description || ''}
            style={{border: '1px solid #0066ff'}}
            onChange={(e) => setGroupDetails({ ...groupDetails, description: e.target.value })}
          />
        </FormGroup>
      </FormRowFull>
      <form>

        <Button primary type="button" onClick={() => onSaveGroup(groupDetails)}>
          Save
        </Button>
      </form>
      </div>}
      {
        <>
          <Divider />
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', marginTop: '1rem' }}>
            <SubSectionTitle>Users</SubSectionTitle>
            <div style={{ marginLeft: 'auto', display: 'flex', gap: '2px', alignItems: 'center' }}>
              <Input type="text" placeholder="Search Users..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <ButtonSuccess onClick={() => onSelectUser({}, groupItem)}><FontAwesomeIcon icon={faPlus} /> User</ButtonSuccess>
            </div>
          </div>
          <Divider />
          <Table>
            <thead>
              <tr>
                <TableHeader>Name </TableHeader>
                <TableHeader>Gender</TableHeader>
                <TableHeader>Email</TableHeader>
                <TableHeader>Actions</TableHeader>
              </tr>
            </thead>
            <tbody>
              {filteredUsers?.map(user => (
                <TableRow key={user.id}>
                  <TableCell>{user.first_name} {user.last_name}</TableCell>
                  <TableCell>{getGender(user.gender)}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>
                    <div style={{ display: 'flex', gap: '0.5rem' }} onClick={() => onSelectUser(user, groupItem)}>
                      <Button style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}>View</Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </tbody>
          </Table>

                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalCount={totalItems}
                    setCurrentPage={setCurrentPage}
                    setTotalPages={setTotalPages}
                    pageSize={itemsPerPage}
                />
        </>
      }
    </div>
  );
};

export default GroupDetails;